import axios from 'axios';
import { createAuthHeaders } from '../../api-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const authApi = {
  /**
   * List users in the auth system
   */
  async listUsers(
    token: string,
    projectId: string,
    page: number = 1,
    perPage: number = 50,
  ): Promise<any> {
    const response = await axios.get(
      `${API_URL}/api/supabase/projects/${projectId}/auth/users?page=${page}&perPage=${perPage}`,
      {
        headers: createAuthHeaders(token),
      },
    );
    return response.data;
  },

  /**
   * Get auth configuration
   */
  async getAuthConfig(token: string, projectId: string): Promise<any> {
    const response = await axios.get(
      `${API_URL}/api/supabase/projects/${projectId}/auth/config`,
      {
        headers: createAuthHeaders(token),
      },
    );
    return response.data;
  },

  /**
   * Update auth configuration
   */
  async updateAuthConfig(
    token: string,
    projectId: string,
    updates: Record<string, any>,
  ): Promise<any> {
    const response = await axios.patch(
      `${API_URL}/api/supabase/projects/${projectId}/auth/config`,
      updates,
      {
        headers: createAuthHeaders(token),
      },
    );
    return response.data;
  },

  /**
   * Create a new auth user
   */
  async createUser(
    token: string,
    projectId: string,
    userData: {
      email: string;
      password: string;
      phone?: string;
      email_confirm?: boolean;
      phone_confirm?: boolean;
      user_metadata?: Record<string, any>;
      app_metadata?: Record<string, any>;
    },
  ): Promise<any> {
    const response = await axios.post(
      `${API_URL}/api/supabase/projects/${projectId}/auth/users`,
      userData,
      {
        headers: createAuthHeaders(token),
      },
    );
    return response.data;
  },

  /**
   * Delete an auth user
   */
  async deleteUser(
    token: string,
    projectId: string,
    userId: string,
  ): Promise<any> {
    const response = await axios.delete(
      `${API_URL}/api/supabase/projects/${projectId}/auth/users/${userId}`,
      {
        headers: createAuthHeaders(token),
      },
    );
    return response.data;
  },

  /**
   * Invite a user by generating an invitation link
   */
  async inviteUser(
    token: string,
    projectId: string,
    inviteData: {
      email: string;
      redirect_to?: string;
    },
  ): Promise<any> {
    const response = await axios.post(
      `${API_URL}/api/supabase/projects/${projectId}/auth/users/invite`,
      inviteData,
      {
        headers: createAuthHeaders(token),
      },
    );
    return response.data;
  },

  /**
   * Send magic link to existing user for passwordless login
   */
  async sendMagicLink(
    token: string,
    projectId: string,
    email: string,
  ): Promise<any> {
    const response = await axios.post(
      `${API_URL}/api/supabase/projects/${projectId}/auth/users/magic-link`,
      { email },
      {
        headers: createAuthHeaders(token),
      },
    );
    return response.data;
  },
};
